





























































import VueI18n from 'vue-i18n'
import { Vue, Component, Prop } from 'vue-property-decorator';

import Icon from '../../../../components/Icon/Icon.vue';
import CashIcon from "../../../../components/Icon/icons/CashIcon.vue";
import { tooltipTrigger } from '../../../utils/tooltipTrigger';

@Component({
  methods: {
    tooltipTrigger
  },
  components: {
    CashIcon,
    Icon
  }
})
export default class PostSettingsIcons extends Vue {
  @Prop({ type: Boolean, required: false, default: false }) isPinned!: boolean

  @Prop({ type: Boolean, required: false, default: false }) isProtectContent!: boolean

  @Prop({ type: Boolean, required: false, default: false }) isDisableNotify!: boolean

  @Prop({ type: Boolean, required: false, default: false }) isRepeat!: boolean

  @Prop({ type: Boolean, required: false, default: false }) isAd!: boolean

  @Prop({ type: Boolean, required: false, default: true }) showExtraSettingIcons!: boolean

  @Prop() i18n!: VueI18n
}
